<template>
  <v-card
      class="pa-2 rounded-lg"
      :elevation="4"
      :min-height="height"
      :max-height="height"
      :min-width="width"
      :max-width="width"
  >
    <v-card
        flat
        color="#013B6C"
        width="100%"
        :height="height - 16"
    >
      <v-img src="@/assets/images/fitt_card_back.svg"></v-img>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "FittCard",
  props: {
    card: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      default: 208,
    },
    height: {
      type: Number,
      default: 320,
    },
  },
  methods: {
    selectCard() {
      this.$emit('select');
    },
  },
}
</script>

<style scoped>
</style>